var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.76 127.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15787",
    d: "m121.03,55.89c-.35-.02-.7-.02-1.05,0v-.48c-.03-3.82-2.54-7.18-6.2-8.28C112.89,20.23,90.36-.86,63.46.03,37.8.87,17.2,21.48,16.36,47.13c-3.82.96-6.52,4.38-6.58,8.32v.44c-.36-.06-.72-.09-1.08-.11-4.79.02-8.67,3.9-8.69,8.69v17.05c.02,4.79,3.9,8.67,8.69,8.69.36-.01.73-.05,1.08-.11v.48c0,4.8,3.9,8.7,8.71,8.69,4.8,0,8.69-3.89,8.69-8.69v-35.14c-.01-.3-.04-.59-.09-.89v-5.63c-.11-20.92,16.76-37.96,37.68-38.07s37.96,16.76,38.07,37.68v4.57c-.23.76-.35,1.55-.35,2.34v35.16c0,.6.07,1.19.2,1.78-2.49,5.56-9.6,19-21.58,22.73-2.01-4.6-7.36-6.7-11.96-4.69-4.6,2.01-6.7,7.36-4.69,11.96,2.01,4.6,7.36,6.7,11.96,4.69,2.75-1.2,4.73-3.68,5.29-6.63,11.62-3.15,19.91-13.76,24.46-22.86,1.46,1.06,3.22,1.63,5.03,1.64,4.8.03,8.72-3.82,8.78-8.62v-.48c.36.06.72.09,1.08.11,4.79-.02,8.67-3.9,8.69-8.69v-17.03c-.06-4.78-3.95-8.62-8.73-8.62h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/CRM.486ea9b564322483d1b73a56f0f5d434.svg";
export { ForwardRef as ReactComponent };